import Vue from 'vue'
import introduce from './introduce.vue'
const Introduce = Vue.extend(introduce)

let introduceV = ''
export function $showIntroduce(data = {}) {
  if (introduceV == '') {
    introduceV = new Introduce({
      data
    }).$mount();
    document.body.appendChild(introduceV.$el)
  }else {
    document.body.removeChild(introduceV.$el);
    introduceV = ''
  }

}


// WEBPACK FOOTER //
// ./src/mixins/mixins.js